import AbstractResource from './AbstractResource';
import DirectoryConfig from '../Configuration/DirectoryConfig';
import { SerializedResource } from '@/types';
import Gallery from './Gallery';
import { resolveResourceFromConfig } from '../../support';

export default class Directory extends AbstractResource {
  protected configuration!: DirectoryConfig;

  constructor(
    protected readonly resource: SerializedResource,
    protected parentDirectory?: Directory
  ) {
    super(resource);

    if (resource.type.toLowerCase() !== 'directory') {
      throw new Error(
        'Only resources of type [directory] can be passed to a new [Directory] resource instance'
      );
    }
  }

  public isDirectory(): boolean {
    return true;
  }

  public isBanner(): boolean {
    return false;
  }

  public children(): AbstractResource[] {
    return (this.info().children || []).map(c =>
      resolveResourceFromConfig(c, this)
    );
  }

  public isVersioned(): boolean {
    return /v\d+/i.test(this.info().basename);
  }

  public parent(): Directory | undefined {
    return this.parentDirectory;
  }

  public version(): number {
    if (!this.isVersioned()) {
      return -1;
    }

    return Number((/v(\d+)/i.exec(this.info().basename) as string[])[1]);
  }

  public config(): DirectoryConfig {
    if (this.configuration) {
      return this.configuration;
    }

    return (this.configuration = new DirectoryConfig(this.info().config));
  }

  public isRoot() {
    return this.parent() === undefined;
  }

  public gallery(): Gallery | null {
    if (!this.config().has('gallery')) {
      return null;
    }

    return new Gallery(this);
  }

  public clone(): Directory {
    return new Directory(this.info(), this.parent());
  }
}
